export default __webpack_public_path__ + "00647f01e10e825169c0f62cccce4c30.jpg";